import React from "react"
import { graphql } from "gatsby"

import { renderAstWithWidgets } from "@utils"

// Shared components
import SEO from "@components/SEO/SEO"

// Custom Events
import { logCustomGAEvent } from "../../../pages/interview-builder/_utils"
import { GA_CUSTOM_EVENTS } from "../../../pages/interview-builder/_store/constants"

// Interview Builder components
import InterviewBuilderContent from "../../../pages/interview-builder/_components/InterviewBuilderContent/InterviewBuilderContent"
import InterviewBuilderHero from "../../../pages/interview-builder/_components/InterviewBuilderHero/InterviewBuilderHero"

export const Head = ({
  data: { markdownRemark: {
    frontmatter: {
      slug,
      title,
    },
  } }
}) => (
  <SEO
    description="Browse our customizable job description templates for common customer-facing roles, each with their own suggested list of targeted interview questions."
    image="/images/pages/interview-builder/InterviewBuilder--meta.png"
    permalink={`/interview-builder/library/${slug}/`}
    title={`${title} - Customer Service Job Description Library by Help Scout`}
  />
)

const JobDescriptionPage = ({
  data: { markdownRemark: {
    frontmatter: {
      pdfLink,
      presetName,
      slug,
      title,
    },
    htmlAst,
  } }
}) => {
  return (
    <>
      <InterviewBuilderHero
        activeTab="/interview-builder/library/"
        backLink="/interview-builder/library/"
        isContentPage
      />
      <InterviewBuilderContent
        title={title}
        actions={[
          {
            title: "Create interview for this role",
            href: `/interview-builder/?preset=${presetName}`,
            onClick: () =>
              logCustomGAEvent(GA_CUSTOM_EVENTS.CREATE_INTERVIEW_FOR_ROLE, {
                preset: presetName,
              }),
          },
          {
            title: "Download job description",
            href: pdfLink,
            onClick: () =>
              logCustomGAEvent(GA_CUSTOM_EVENTS.DOWNLOAD_JOB_DESCRIPTION, {
                preset: presetName,
              }),
          }
        ]}
      >
        {renderAstWithWidgets(htmlAst)}
      </InterviewBuilderContent>
    </>
  )
}

export const pageQuery = graphql`
  query JobDescriptionPageQuery(
    $id: String!
  ) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        presetName
        slug
        title
        pdfLink
      }
      htmlAst
    }
  }
`

export default JobDescriptionPage
